import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function PricingCTA() {
  return <SectionWrapper alternate id="pricing" data-id="element-381">
      <motion.div className="text-center" variants={childVariants} data-id="element-382">
        <motion.p className="font-body text-cream-muted mb-6 text-[24px]" variants={childVariants} data-id="element-383">
          Get The 3AM Reset Today
        </motion.p>

        <motion.div className="flex items-center justify-center gap-3 mb-2" variants={childVariants} data-id="element-384">
          <span className="font-heading md:text-3xl text-cream-muted line-through decoration-cream-faint/50 text-[18px]" data-id="element-385">
            USD 19.99
          </span>
          <span className="font-heading md:text-6xl font-bold text-cream text-[32px]" data-id="element-386">
            USD 6.39
          </span>
          <span className="bg-amber/90 text-deep font-body font-bold px-3 py-1 rounded-full tracking-wide text-[14px]" data-id="element-387">
            68% OFF
          </span>
        </motion.div>

        <motion.div className="mb-6" variants={childVariants} data-id="element-388">
          <CTAButton className="text-xl px-10 py-5" data-id="element-389">
            Download The 3AM Reset Now
          </CTAButton>
        </motion.div>

        <motion.p className="font-body text-base text-cream-muted mb-12" variants={childVariants} data-id="element-390">
          Instant PDF download
        </motion.p>

        <motion.div className="h-px w-16 bg-teal/20 mx-auto mb-10" variants={childVariants} data-id="element-391" />

        <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-392">
          And the next time you wake up at 3:12am with your brain trying to drag
          you into a spiral…
        </motion.p>

        <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-393">
          You won't have to think.
        </motion.p>

        <motion.p className="font-heading text-xl md:text-2xl text-teal-light font-semibold" variants={childVariants} data-id="element-394">
          You'll just run the protocol.
        </motion.p>
      </motion.div>
    </SectionWrapper>;
}